export default __webpack_public_path__ + "static/logo-zkb-7a06dc6e51b6d138c71dc133f8885bf6.png";